// model
import { IService } from "@/model/Service/Service"
import ParticipantInsurance from "@/model/Insurance/ParticipantInsurance"
import { IInsurance } from "@/model/Insurance/Insurance"
import ParticipantService from '@/model/Service/ParticipantService'
import AccomodationService from '@/model/Service/AccomodationService'


const getSelectedQuantityForOption = (option: IService | IInsurance): number => {
    if (option instanceof ParticipantService) {
        return option.getTravellersSelected().length
    } else if (option instanceof AccomodationService) {
        return option.getQuantitySelected()
    } else if (option instanceof ParticipantInsurance) {
        return Number(option.getQuantity())
    } else {
        throw new Error("option has to be a participant or accomodation option")
    }
}

export default getSelectedQuantityForOption